import React, { useState, useCallback } from 'react';
import cookies from 'js-cookie';
import Modal from 'react-responsive-modal';
import { logout as logoutFromCognito } from '../services/cognito/cognito';
import config from '../services/config';

import Crying_circly from '../img/crying_circly.svg';
import '../style/Modal.css';

const handleLogout = async () => {
  sessionStorage.clear();
  cookies.remove(config.cookieName);

  logoutFromCognito();
};

const LogoutButton = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = useCallback(() => setIsModalOpen(true), []);
  const closeModal = useCallback(() => setIsModalOpen(false), []);

  return (
    <>
      <button className="btn btn-secondary" id="logout" onClick={openModal}>
        Logout
      </button>

      <Modal
        open={isModalOpen}
        onClose={closeModal}
        closeIconSize={26}
        classNames={{ modal: 'modal-bg', closeIcon: 'close-icon' }}
        center
      >
        <div className="">
          <div className="logout-img">
            <img src={Crying_circly} alt="crying circly" />
          </div>
          <h4 className="m-b-2">Are you sure you want to leave?</h4>
          <div className="">
            <button className="btn btn-secondary m-r-2" onClick={closeModal}>
              No
            </button>
            <button className="btn btn-primary" onClick={handleLogout}>
              Yes
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default LogoutButton;
